module.exports = __webpack_public_path__ + "img/cabbage-posterized-medium-bravo.ed5bcfde.png";